import styled from "styled-components";
import { devices } from "../../Constants";

export const DashboardWrapper = styled.section`
	@media (${devices._sm}) {
		padding: 25px 27px 40px 25px;
	}
	padding: 40px 30px 20px 50px;
	color: #555555;
`;

export const HeaderWrapper = styled.header`
	display: flex;
	width: 100%;
	align-items: center;

	.intro {
		display: flex;
		gap: 1rem;
		align-items: center;
		flex: 1 1 0%;
	}

	.date {
		display: flex;
		gap: 0.5rem;
	}

	& > header {
		display: flex;
		width: 100%;
		justify-content: space-between;
	}
`;

export const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 15px;
	gap: 15px;

	@media only screen and ${devices.lg} {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		margin-top: 30px;
		gap: 15px;
		overflow-y: auto;
	}
`;

export const UsersCardWrapper = styled(CardWrapper)`
	display: flex;
	flex-direction: column;
	margin-top: 15px;
	gap: 15px;

	@media only screen and ${devices.lg} {
		display: grid;
		grid-template-columns: 1fr 1fr;
		margin-top: 30px;
		gap: 15px;
	}
`;

export const ChartCardContent = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 0.35rem;

	@media (${devices.sm}) {
		gap: 4rem;
		justify-content: start;
	}
`;

export const ActivitySection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 25px;
	margin-top: 20px;

	.users {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	@media only screen and ${devices.md} {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 15px;
		margin-top: 40px;
	}
`;

export const UserCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const TableSection = styled.div`
	border: none;
	height: 100%;
	background-color: #ffffff;
	border: 1px solid #b8c8cf;
	box-shadow: 0px 15px 50px rgba(0, 103, 112, 0.05);
	border-radius: 20px;
	padding: 20px;
	box-sizing: border-box;

	button {
		border: none;
		background: rgba(0, 103, 112, 0.03);
		box-shadow: 0px 4px 4px rgba(0, 103, 112, 0.05);
		color: #006770;
		padding: 5px 10px;
		border-radius: 5px;
		cursor: pointer;
	}

	header {
		display: flex;
		justify-content: space-between;

		.activity {
			color: #333333;
			font-weight: 700;
			font-size: 20px;
		}
	}
`;
